<template>
  <b-card class="verify-form" :title="header">
    <b-card-sub-title class="mb-2">
      Input the code sent to: <span>{{ value }}</span>
    </b-card-sub-title>

    <b-form
      class="form"
      onkeydown="return event.key != 'Enter'"
      @submit.prevent="onSubmit"
    >
      <b-form-group>
        <code-input
          ref="code"
          v-model="form.code"
          :loading="form.$busy"
          :field-width="42.5"
          :field-height="42.5"
          :is-invalid="form.$getError('token')"
          required
          autoFocus
          @complete="onSubmit"
        ></code-input>
      </b-form-group>

      <error-message
        class="mb-2 mt-3"
        sign=""
        :error="
          form.$getError('via') || form.$getError('token') || form.$errorMessage
        "
      ></error-message>

      <hr class="card-divider" />

      <div class="modal__footer modal__footer--single">
        <resend-verification-code-form
          :form="form"
          :to="'verify-' + to"
          class="forgot-btn mt-3"
        >
        </resend-verification-code-form>

        <div class="align-right">
          <b-button
            type="submit"
            variant="primary"
            class="btn--xs"
            :disabled="form.$busy"
          >
            <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;{{ button }}
          </b-button>
        </div>
      </div>
    </b-form>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Change email form
 * ==================================================================================
 **/

import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import ErrorMessage from '@/components/inputs/ErrorMessage'
import CodeInput from '@/components/inputs/CodeInput'
import ResendVerificationCodeForm from '@/components/forms/ResendVerificationCodeForm.vue'

export default {
  components: {
    ErrorMessage,
    CodeInput,
    ResendVerificationCodeForm
  },
  props: {
    to: {
      type: String,
      default: 'email',
      validation: function(value) {
        return ['email', 'phone'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    value() {
      if (!this.user) return ''
      return this.to === 'email' ? this.user.email : this.user.phone_number
    },

    label() {
      return this.to === 'email' ? 'email' : 'phone number'
    },

    tag() {
      return this.to === 'email' ? 'email' : 'phone_number'
    },

    header() {
      return this.to === 'email' ? 'Verify email' : 'Verify your phone number'
    },

    button() {
      return 'Verify ' + this.label
    }
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.form.email = newValue.email
        this.form.phone_number = newValue.phone_number
      }
    }
  },
  data: function() {
    return {
      form: new Form({
        email: null,
        phone_number: null,
        code: null
      })
    }
  },
  methods: {
    ...mapActions({
      verifyUser: 'auth/verifyUser'
    }),

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await this.verifyUser({
        token: this.form.code,
        via: this.tag
      }).catch(error => {
        this.form.$setLoading(false)
        this.form.$handleError(error)
        this.setFocus('code')
      })
    },

    setFocus(ref) {
      this.$nextTick(() => {
        if (!this.$refs[ref]) return
        this.$refs[ref].focus()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.verify-form {
}
</style>
